import {removeClass, toggleClass} from "../_vars";

export const menuFunc = () => {
   const togglePanel = document.querySelector(".open-panel");
   const panel = document.querySelector(".panel");
   const stickyBlock = document.querySelector(".sticky-block");
   const closePanel = document.querySelector(".panel__close");
   if (panel) {
      const label = togglePanel.querySelector(".open-panel__switcher");
      togglePanel.addEventListener("click", () => {
         toggleClass(panel, "--show");
         toggleClass(togglePanel, "--active");
         toggleClass(stickyBlock, "--hide");
         if (panel.classList.contains("--show")) document.body.style.overflow = "hidden";
         else document.body.style.overflow = "";
         panel.classList.contains("--show")
            ? (label.textContent = "Закрыть")
            : (label.textContent = "Меню");
      });
      closePanel.addEventListener("click", () => {
         removeClass(panel, "--show");
         removeClass(togglePanel, "--active");
         removeClass(stickyBlock, "--hide");
         document.body.style.overflow = "";
         label.textContent = "Меню";
      });
   }
   addEventListener("click", (e) => {
      const button = e.target.closest(".panel-list__link.menu__link, .item-panel__button");
      if (!button) return;

      const parent = button.closest(".panel-list__item");
      toggleClass(parent, "--active");
   })
};
